import * as React from 'react';
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import logo from '../assets/LideresenMovimiento.png';
import { styled } from '@mui/material/styles';
import ModalMenu from './ModalMenu';
import { useNavigate } from "react-router-dom";
import routes from '../../routers/routes';

const Logo = styled('img')({
  maxHeight: '36px',
});

export default function DenseAppBar() {
  let navigate = useNavigate();

  return (
    <Box sx={{ flexGrow: 1 }}>
      <AppBar position="static" sx={{ backgroundColor:'#00000066' }}>
        <Toolbar variant="dense" sx={{ justifyContent: 'space-between', backgroundColor:'#00000066', zIndex: 1100 }}>
          <Logo
            src={logo}
            onClick={() => navigate(routes.root)}
            alt="Líderes en Movimiento Logo"
            sx={{ cursor: 'pointer' }}
          />
          <ModalMenu />
        </Toolbar>
      </AppBar>
    </Box>
  );
}
